import styles from './ImageOverlay.module.css';

const ImageOverlay = () => {
  return (
    <>
      <div className={styles.gradientOverlayRight} />
      <div className={styles.gradientOverlayLeft} />
    </>
  );
}

export default ImageOverlay